// Landing.jsx
import React from "react";
import { Helmet } from "react-helmet-async"; // 👈 AÑADIR
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import VozDemo from "../components/VozDemo";
import AsistenteDemo from "../components/AsistenteDemo";
import AsistenteFab from "../components/AsistenteFab";
import Plans from "../components/Plans";
import Workouts from "../components/Workouts";
import WhyWayo from "../components/WhyWayo";
import Waitlist from "../components/Waitlist";
import FAQ from "../components/FAQ";
import BlogHighlights from "../components/BlogHighlights";
import Footer from "../components/Footer";
import "./Landing.css";

export default function Landing() {
  return (
    <>
      {/** SEO Meta tags **/}
      <Helmet>
        <title>Wayo - App para Contar Calorías con Foto | Coach de Nutrición con IA</title>
        <meta name="description" content="Escanea tu comida con una foto o cuéntale lo que has comido y Wayo te da las calorías. El único asistente de nutrición con IA que sabe lo que has comido hoy. 7 días Premium gratis." />
        <meta name="keywords" content="asistente de nutrición con IA, chat nutricionista IA, app contar calorías, contar calorías con foto, escáner de comidas, app nutrición IA, perder peso, ganar músculo, plan de dieta, rutinas de entrenamiento, Wayo" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Wayo - App para Contar Calorías con Foto | IA" />
        <meta property="og:description" content="Escanea tu comida con una foto o simplemente cuéntasela, y conoce calorías y macros al instante. Planes personalizados de nutrición y entrenamiento." />
        <meta property="og:image" content="https://wayoai.app/assets/img/og-wayo.jpg" />
        <meta property="og:image:alt" content="Wayo, app de nutrición y fitness con IA" />
        <meta property="og:url" content="https://wayoai.app/" />
        <meta property="og:site_name" content="Wayo" />
        <meta property="og:locale" content="es_ES" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Wayo - App para Contar Calorías con Foto" />
        <meta name="twitter:description" content="Escanea tu comida, conoce calorías y macros al instante y recibe planes personalizados con IA." />
        <meta name="twitter:image" content="https://wayoai.app/assets/img/og-wayo.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://wayoai.app/" />

        {/* Schema.org JSON-LD vive como fuente única en public/index.html
            (Organization + WebSite + MobileApplication) para que lo vean los
            crawlers sin ejecutar JS. No re-inyectar aquí: duplicarlo genera
            entidades en conflicto. */}
      </Helmet>
      

      <main className="landing">
        <Header />
        <Hero />
        <VozDemo />
        <AsistenteDemo />
        <Plans />
        <Workouts />
        <WhyWayo />
        <section className="landing-seo-hub">
          <div className="landing-seo-hub-inner">
            <div className="landing-seo-hub-copy">
              <span className="landing-seo-hub-badge">Explora más</span>
              <h2>Páginas útiles para comparar apps y herramientas</h2>
              <p>
                Si vienes buscando una solución concreta, aquí tienes accesos directos a nuestras comparativas y páginas de producto más útiles.
              </p>
            </div>
            <div className="landing-seo-hub-grid">
              <Link to="/alternativa-myfitnesspal" className="landing-seo-card">
                <strong>Alternativa a MyFitnessPal</strong>
                <span>Menos registro manual y mejor experiencia con comida real.</span>
              </Link>
              <Link to="/app-para-contar-calorias-con-foto" className="landing-seo-card">
                <strong>App para contar calorías con foto</strong>
                <span>Más rapidez para registrar platos caseros y comidas reales.</span>
              </Link>
              <Link to="/app-para-contar-macros" className="landing-seo-card">
                <strong>App para contar macros</strong>
                <span>Proteína, carbohidratos y grasas sin tanta fricción.</span>
              </Link>
              <Link to="/coaches" className="landing-seo-card">
                <strong>Software para entrenadores personales</strong>
                <span>Clientes, rutinas y dietas en un solo sitio, gratis.</span>
              </Link>
            </div>
          </div>
        </section>
        <Waitlist />
        <FAQ />
        <BlogHighlights />
        <Footer />
      </main>

      {/* Burbuja flotante abajo a la derecha: fuera del flujo de la página */}
      <AsistenteFab />
    </>
  );
}
